import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { Button, Column } from 'Components/UI'

import {
  LANDING_CONTENT_PX,
  LANDING_CONTENT_WIDTH_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import Gallery from './Gallery'
import Title from './Title'

type Props = {
  onAction?: () => void
}

function ExecutiveInviteWelcomeSection({ onAction }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          alignCenter
          fullWidth
          gap={LANDING_SECTION_GAP}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          py={LANDING_SECTION_PY}
        >
          <Title />

          <Gallery />

          <Button large width={isMobile ? 1 : undefined} onClick={onAction}>
            Book a Meeting
          </Button>
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default ExecutiveInviteWelcomeSection
